import React, { useEffect, useContext, useState } from "react";
import app from '../firebaseConfig'
import { Table, Tag, Space, Input, Button, Select, Avatar, Popconfirm, message, Collapse, Modal, Drawer, Icon, Menu } from 'antd';
import { useHistory } from "react-router-dom";
import { withRouter } from "react-router";
import { makeStyles } from '@material-ui/core/styles';
import { Auth } from "../context/AuthContext";
import { denominaciones, grupos, allowedMails } from "../config/constantes"



const WineSvg = () => (
  <svg width="20px" height="20px" fill="currentColor" viewBox="0 0 20 20">
    <path  d="M 9.085938 0.285156 C 9.011719 0.328125 8.914062 0.425781 8.871094 0.5 C 8.789062 0.636719 8.785156 0.71875 8.785156 2.921875 L 8.785156 5.203125 L 8.527344 5.347656 C 8.140625 5.554688 7.738281 5.992188 7.527344 6.40625 C 7.21875 7.042969 7.230469 6.671875 7.246094 13.257812 L 7.257812 19.160156 L 7.382812 19.363281 C 7.480469 19.519531 7.566406 19.597656 7.734375 19.683594 L 7.964844 19.800781 L 12.035156 19.800781 L 12.265625 19.683594 C 12.433594 19.597656 12.519531 19.519531 12.617188 19.363281 L 12.742188 19.160156 L 12.753906 13.257812 C 12.769531 6.671875 12.78125 7.042969 12.472656 6.40625 C 12.261719 5.992188 11.859375 5.554688 11.472656 5.347656 L 11.214844 5.203125 L 11.214844 2.921875 C 11.214844 0.71875 11.210938 0.636719 11.128906 0.5 C 10.964844 0.226562 10.867188 0.199219 10 0.199219 C 9.300781 0.199219 9.210938 0.207031 9.085938 0.285156 Z M 10.628906 1.121094 L 10.628906 1.414062 L 9.371094 1.414062 L 9.371094 0.828125 L 10.628906 0.828125 Z M 10.621094 2.953125 L 10.605469 3.863281 L 9.394531 3.863281 L 9.378906 2.953125 L 9.371094 2.042969 L 10.628906 2.042969 Z M 10.628906 5.042969 C 10.640625 5.394531 10.671875 5.609375 10.703125 5.652344 C 10.734375 5.691406 10.867188 5.757812 11 5.808594 C 11.410156 5.957031 11.714844 6.230469 11.925781 6.648438 C 12.101562 6.992188 12.136719 7.210938 12.136719 8.019531 L 12.136719 8.785156 L 7.863281 8.785156 L 7.863281 8.015625 C 7.863281 7.375 7.875 7.199219 7.945312 6.988281 C 8.105469 6.460938 8.542969 5.972656 9 5.808594 C 9.351562 5.679688 9.371094 5.640625 9.371094 5.03125 C 9.371094 4.757812 9.382812 4.511719 9.402344 4.496094 C 9.417969 4.484375 9.695312 4.476562 10.015625 4.480469 L 10.605469 4.492188 Z M 11.839844 9.476562 C 11.914062 9.523438 12.015625 9.628906 12.054688 9.707031 C 12.132812 9.84375 12.136719 9.996094 12.136719 12.449219 C 12.136719 14.90625 12.132812 15.054688 12.054688 15.195312 C 12.015625 15.273438 11.914062 15.378906 11.839844 15.421875 C 11.703125 15.503906 11.609375 15.507812 10.042969 15.519531 C 8.390625 15.53125 8.386719 15.53125 8.203125 15.4375 C 7.847656 15.253906 7.863281 15.398438 7.863281 12.457031 C 7.863281 10.175781 7.871094 9.847656 7.929688 9.722656 C 8.09375 9.378906 8.148438 9.371094 10.0625 9.386719 C 11.613281 9.394531 11.703125 9.398438 11.839844 9.476562 Z M 12.136719 17.550781 C 12.136719 18.78125 12.128906 19 12.070312 19.078125 L 12.007812 19.171875 L 10.011719 19.171875 C 8.214844 19.171875 8.011719 19.164062 7.941406 19.101562 C 7.867188 19.039062 7.863281 18.933594 7.863281 17.570312 L 7.863281 16.113281 L 12.136719 16.113281 Z M 12.136719 17.550781 "/>
  </svg>
);


const WineIcon = (props) => (
  <Icon component={WineSvg} {...props} />
);


const { SubMenu } = Menu;

const useStyles = makeStyles((theme) => ({
  titulo:{
    fontSize:"20px"
  },
  boton:{
    float: "left",
    marginLeft: "10px",
    marginBottom: "5px"
  },
  avatar: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px',
    background: '#eee'
  },
  listmenu: {
    listStyleType: "none",
    paddingLeft: "0px"
  },
  drawer: {
    padding: "0px",
    "& .ant-drawer-body": {
      padding: "0px"
    },
    "& .ant-menu-inline": {
      border: "none"
    }
  },

}));

const MenuAdmin = ({ history,titulo }) => {
  const classes = useStyles();

  const { usuario } = useContext(Auth);

  const [visible, setVisible] = useState(false);


  const showDrawer = () => {
    setVisible(true)
  };

  const onClose = () => {
    setVisible(false)
  };


  return (
    <>
      {usuario && <div className={classes.avatar}>
        {/* <Button onClick={(e) => { window.open('/comandasboard', "_self") }}>Comandas</Button>
        <Button onClick={(e) => { window.open('/stock', "_self") }}>Stock</Button> */}
        <Button onClick={showDrawer}><Icon type="menu" /></Button>
        <h1 className={classes.titulo}>{titulo}</h1>
        <Avatar src={usuario.photoURL} />

        <Drawer
          title="Menú"
          placement="left"
          closable={true}
          onClose={onClose}
          visible={visible}
          className={classes.drawer}
        >

          <Menu mode="inline" className={classes.menu}>

          <Menu.Item key="editarmenu">
              <a href="/editarmenu" rel="noopener noreferrer">
                <Icon type="clock-circle" /> Menú y horario</a>
            </Menu.Item>
            <Menu.Item key="comanda">
              <a href="/comanda" rel="noopener noreferrer">
                <Icon type="plus" /> Nueva comanda</a>
            </Menu.Item>
            <Menu.Item key="comandasboard">
              <a href="/comandasboard" rel="noopener noreferrer">
                <Icon type="pushpin" /> Comandas</a>
            </Menu.Item>
            <Menu.Item key="stock">
              <a href="/stock" rel="noopener noreferrer">
                <Icon type="unordered-list" /> Stock</a>
            </Menu.Item>
            <Menu.Item key="altaplato">
              <a href="/altaplato" rel="noopener noreferrer">
                <Icon type="plus" /> Alta Plato</a>
            </Menu.Item>
            <Menu.Item key="platos">
              <a href="/platos" rel="noopener noreferrer">
                <Icon type="read" /> Platos</a>
            </Menu.Item>
            <Menu.Item key="altavino">
              <a href="/altavino" rel="noopener noreferrer">
                <Icon type="plus" /> Alta vino</a>
            </Menu.Item>
            <Menu.Item key="vinos">
              <a href="/vinos" rel="noopener noreferrer">
              <WineIcon style={{ color: 'black' }} />Vinos</a>
            </Menu.Item>


          </Menu>
          
          <hr />
          
          <div className={classes.boton}><Button onClick={() => history.push("/")} type="primary"><Icon type="home" />Home</Button></div>
          
          <div className={classes.boton}><Button onClick={() => app.auth().signOut()} key="logout" type="primary"><Icon type="logout" />Cerrar Sesión</Button></div>

        </Drawer>

      </div>}

    </>

  );
}

export default withRouter(MenuAdmin);
